(function () {
  var PHONE = '+61408503593';
  var PHONE_DIGITS = '61408503593';
  var EMAIL = 'cuts@likebutter.com.au';
  var SMS_BODY = 'Hi Jem, I have a question about ';
  var WA_TEXT = 'Hi Jem, I have a question about ';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function buildSmsHref() {
    var body = encodeURIComponent(SMS_BODY);
    return 'sms:' + PHONE + '?body=' + body;
  }

  function buildWaHref() {
    var text = encodeURIComponent(WA_TEXT);
    return 'https://wa.me/' + PHONE_DIGITS + '?text=' + text;
  }

  function showFeedback(feedbackEl, message) {
    if (!feedbackEl) return;
    feedbackEl.textContent = message;
    feedbackEl.hidden = false;
    setTimeout(function () {
      feedbackEl.hidden = true;
    }, 4000);
  }

  function copyPhone(feedbackEl) {
    var text = PHONE;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () {
        showFeedback(
          feedbackEl,
          'Signal number copied (' +
            PHONE +
            '). Open Signal → New chat → search that number.'
        );
      });
    }
    showFeedback(feedbackEl, 'In Signal, message ' + PHONE);
    return Promise.resolve();
  }

  function copyEmail(feedbackEl) {
    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      window.location.href = 'mailto:' + EMAIL;
      return;
    }
    navigator.clipboard.writeText(EMAIL).then(function () {
      showFeedback(feedbackEl, 'Email copied: ' + EMAIL);
    });
  }

  function init() {
    var toggle = qs('#lb-contact-toggle');
    var panel = qs('#lb-contact-panel');
    var copyBtn = qs('#lb-contact-copy-email');
    var feedback = qs('#lb-contact-feedback');
    var smsLink = qs('#lb-contact-sms');
    var waLink = qs('#lb-contact-whatsapp');
    var signalLink = qs('#lb-contact-signal');

    if (!toggle || !panel) return;

    if (smsLink) smsLink.href = buildSmsHref();
    if (waLink) waLink.href = buildWaHref();
    if (signalLink) {
      signalLink.addEventListener('click', function (e) {
        e.preventDefault();
        copyPhone(feedback);
      });
    }

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('is-open', open);
      panel.hidden = !open;
      toggle.querySelector('.lb-contact__toggle-label').textContent = open
        ? 'Close'
        : 'Message Jem';
    }

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      setOpen(!isOpen);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
      }
    });

    document.addEventListener('click', function (e) {
      if (
        toggle.getAttribute('aria-expanded') === 'true' &&
        !panel.contains(e.target) &&
        !toggle.contains(e.target) &&
        !e.target.closest('[data-lb-open-contact]')
      ) {
        setOpen(false);
      }
    });

    if (copyBtn && feedback) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        copyEmail(feedback);
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lb-open-contact]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();
      setOpen(true);

      if (
        window.PXUTheme &&
        window.PXUTheme.jsAjaxCart &&
        typeof window.PXUTheme.jsAjaxCart.hideDrawer === 'function'
      ) {
        window.PXUTheme.jsAjaxCart.hideDrawer();
      }
    });

    document.addEventListener('lb-contact:open', function () {
      setOpen(true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
